import React from 'react';
import styled from 'styled-components';
import {
  BodyText,
  Button,
  ModalWindow,
  SwitchDialogWindows,
  ErrorMessage,
  Header3Text,
  Header4Text,
  FlexRow,
} from 'ui-toolkit';
import { useAsyncOperationWithData } from '../../utilities/accounting/hooks/useAsyncOperationWithData';
import { removeConversationOrderAsync } from '../../API/conversations/removeConversationOrderAsync';
import { UUID } from '../../types/shared/UUID';

const ButtonGrid = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing5};
  grid-auto-columns: max-content;
  grid-auto-flow: column;
`;

export interface IDeleteConvesationOrderModalContainerProps {
  genesysId: UUID;
  orderId?: UUID;
  onClose: () => void;
  onSuccess: () => void;
}

export const DeleteConversationOrderModalContainer: React.FC<IDeleteConvesationOrderModalContainerProps> = ({
  genesysId,
  orderId,
  onClose,
  onSuccess,
}) => {
  const [{ fetchStatus, fetchError }, deleteConversationOrder] =
    useAsyncOperationWithData(removeConversationOrderAsync);
  const onConfirmClick = () => {
    if (orderId) deleteConversationOrder({ orderId, genesysId });
  };

  return (
    <SwitchDialogWindows
      isLoading={fetchStatus.fetching}
      isCompleted={fetchStatus.fetched}
      isError={!!fetchError}
      errorTitle={<Header3Text>There was an error deleting this conversation link</Header3Text>}
      loadingTitle="Deleting Conversation Link..."
      successTitle="Conversation Link was deleted."
      errorMessage={<ErrorMessage error={fetchError} />}
      onCloseClick={() => {
        if (!fetchStatus.fetching) {
          if (fetchStatus.fetched && fetchStatus.success) onSuccess();
          onClose();
        }
      }}
    >
      <ModalWindow
        title={<Header4Text>Delete Conversation Link</Header4Text>}
        onClose={onClose}
        footer={
          <FlexRow justifyContent={'flex-end'}>
            <ButtonGrid>
              <Button intent="secondary" onClick={onClose}>
                Cancel
              </Button>
              <Button intent="primary" onClick={onConfirmClick}>
                Confirm
              </Button>
            </ButtonGrid>
          </FlexRow>
        }
      >
        <BodyText>Are you sure you want to delete this Conversation Order?</BodyText>
      </ModalWindow>
    </SwitchDialogWindows>
  );
};
